<template>

    <div class="login row justify-content-center" style="height: 100vh; background-color: #eaeaea; align-items: center">

        <div class="col-10 col-md-6" style="max-width: 475px">
            <div class="row">

                <div class="col-12 text-center" >
                    <img
                        src="@/assets/img/mi-logo-250.png"
                        alt=""
                    />
                </div>
            </div>

            <div class="mt-1"></div>
            
            <h3 class="text-dark text-center">Client Login</h3>
                
                <div class="login-alert-danger" role="alert" v-if="hasError">
                    {{ messages.loginError }} 
                </div>
                
                <div class="mt-3">

                    <form @submit.prevent>
                        <div class="row">

                            <div class="col-12">
                                <fg-input
                                    type="text"
                                    label="Email"
                                    placeholder="Email"
                                    v-model="user.username"
                                >
                                </fg-input>
                            </div>

                            <div class="col-12">
                                <fg-input
                                    type="password"
                                    label="Password"
                                    v-model="user.password"
                                >
                                </fg-input>
                            </div>
                        </div>

                        <div class="text-center mt-2">
                            <p-button
                                class="btn-primary btn-block mt-4"
                                type="primary"
                                @click.native.prevent="updateProfile"
                            >
                                Login
                            </p-button>
                        </div>

                        <div class="clearfix"></div>
                    </form>
                </div>

            <!--<div class="row">

                <div class="col-12">
                    Help
                </div>
            </div>-->

        </div>
    </div>
</template>



<script>
import {default as session} from '../session.js';
export default {
    mixins: [session],
    data() {
        return {
            user: {
                username: "",
                password: "",
            },
            hasError: false,
            messages: {
                loginError: "We were unable to log you in. Please double chek yout email and password and try again."
            }
        };
    },


    methods: {
        updateProfile() {
            this.processLogin();
        },

        async processLogin() {
            const queryString = new URLSearchParams({
                username: this.user.username,
                password: this.user.password,
            }).toString();

            fetch(
                "https://dashboard.missingink.com/api/v1/auth?" + queryString
            )
            .then((response) => response.json())
            .then((res) => {

               if (res.status >= 400 && res.status < 600) {
                    this.hasError = true;
                    throw new Error("Bad response from server");
                }
        
                this.data = res;

                this.$cookies.set("token", this.data.token);
                this.$cookies.set("moniker", this.data.moniker);
                this.$cookies.set("user", this.data.user);

                this.sessionSet("sites", JSON.stringify(this.data.sites));

                this.$updateConfigVariables({
                    token: this.data.token,
                    moniker: this.data.moniker,
                    sites: this.data.sites,
                });
                
                this.$router.push("/dashboard");
            });
        },
    }
};
</script>
<style>
.login input.form-control {
    border-radius: 0 !important;
    box-shadow: 6px 6px 0 #dedede;
    font-size: 18px;
}
.login input.form-control:active,
.login input.form-control:focus {
    box-shadow: none;

}
.login .btn {
    border-radius: 0 !important;
    box-shadow: 6px 6px 0 #999;
    font-size: 18px;
}
.login-alert-danger {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;

    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;}

</style>
